module.exports = __webpack_public_path__ + "static/fonts/Helios.f835307.eot";